import classNames from 'classnames';
import { isValidElement } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import useStyles from './styles';
import IImageWithTextSection from './types';

function ImageWithTextSection({
  className,
  textContainerClassName,
  textHeadingClassName,
  imageContainerClassName,
  imgSrc,
  imgAlt,
  imgContainerClassName,
  children,
  title,
  smallTitle,
  titleElement = 'h2',
  smallTitleElement = 'p',
  descriptionElement = 'p',
  description,
  imageRight = false,
  imageWidth = 'auto',
  descriptionFontSmall = true,
  titleCentered = false,
  mobileImageFirst = false,
  onClick,
}: IImageWithTextSection) {
  const Title = titleElement;
  const SmallTitle = smallTitleElement;
  const Description = descriptionElement;
  const classes = useStyles({
    descriptionFontSmall,
    titleCentered,
    mobileImageFirst,
  });

  return (
    <section className={classNames(classes.root, imageRight && classes.inverse, className)}>
      {title && titleCentered && <Title className={classNames(classes.heading)}>{title}</Title>}
      <div
        className={classNames(
          classes.content,
          imageContainerClassName,
          imageRight && classes.inverse,
        )}
      >
        <div className={classNames(classes.imgContainer, imgContainerClassName)}>
          {isValidElement(imgSrc) ? (
            <>{imgSrc}</>
          ) : (
            <LazyLoadImage
              width={imageWidth}
              className={classes.img}
              src={imgSrc}
              alt={imgAlt}
              onClick={onClick ? onClick : null}
            />
          )}
        </div>
        <div className={classNames(classes.textContainer, textContainerClassName)}>
          {title && !titleCentered && (
            <Title className={classNames(classes.heading, textHeadingClassName)}>{title}</Title>
          )}
          {smallTitle && <SmallTitle className={classes.smallTitle}>{smallTitle}</SmallTitle>}
          {description && <Description className={classes.paragraph}>{description}</Description>}
          {children && <div className={classes.paragraph}>{children}</div>}
        </div>
      </div>
    </section>
  );
}

export default ImageWithTextSection;
